import script from "./RicetteTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable2.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable2.vue?vue&type=style&index=0&id=7597285b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7597285b"]])

export default __exports__